var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "btns",
    staticStyle: {
      display: "flex"
    }
  }, [_vm.dashboardFrontPage ? _c("div", {
    staticClass: "btn",
    class: _vm.activeKey == 1 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("首页")) + " ")]) : _vm._e(), _vm.dashboardDataBoard ? _c("div", {
    staticClass: "btn",
    class: _vm.activeKey == 2 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(2);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("数据看板")) + " ")]) : _vm._e()]), _vm.activeKey == 1 ? _c("custom", {
    ref: "customRef",
    attrs: {
      customerId: Number(_vm.id),
      menu: "customer.dashboardFrontPage",
      frontPage: _vm.frontPage
    },
    on: {
      ok: _vm.jumpFun,
      setItem: _vm.setItem
    }
  }) : _vm._e(), _vm.activeKey == 2 ? _c("bulletin-board", {
    ref: "bulletinBoardRef",
    attrs: {
      id: Number(_vm.id),
      menu: "customer.dashboardDataBoard",
      bulletinBoardList: _vm.bulletinBoardList,
      delList: _vm.delList
    },
    on: {
      ok: _vm.backFun,
      back: _vm.jumpFun2,
      setObj: _vm.setObjFun,
      delArr: _vm.delArrFun
    }
  }) : _vm._e(), _c("div", {
    staticClass: "marginT20 btnBox"
  }, [_c("a-button", {
    staticClass: "marginR15",
    staticStyle: {
      width: "200px"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("back");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };